import React from "react";
import style from "./index.module.scss";
import { Badge, Button, Icon, Select } from "antd";
import Config from "../../../../../../config";

import useWeekPicker from "../../../../utils/useWeekPicker";
import { Link } from "react-router-dom";
import { useAtomValue } from "jotai";
import { studentEvaluationStatusAtom } from "../../../../store";

interface WeekPickerProps {
    week: number;
    currentWeek: number;
    onChange: (week: number) => void;
}

export default function WeekPicker({
    week,
    currentWeek,
    onChange
}: WeekPickerProps) {
    const { isCurrentBatch } = useWeekPicker(week, onChange);
    const isEvaluation = useAtomValue(studentEvaluationStatusAtom);

    return (
        <div className={style.root}>
            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => onChange(Math.max(week - 1, 1))}
                disabled={week === 1}>
                <Icon type="left" className={style.icon} />
            </Button>

            <Select
                value={week}
                onChange={onChange}
                className={style.select}
                dropdownClassName={style.dropdown}>
                {new Array(Config.MaxWeek).fill(1).map((_, index) => (
                    <Select.Option value={index + 1} key={index}>
                        第&nbsp;&nbsp;{index + 1}&nbsp;&nbsp;周
                    </Select.Option>
                ))}
            </Select>

            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => onChange(Math.min(week + 1, Config.MaxWeek))}
                disabled={week === Config.MaxWeek}>
                <Icon type="right" className={style.icon} />
            </Button>

            <div className={style.count}>共{Config.MaxWeek}周</div>

            <Button
                type="link"
                className={style.reset}
                onClick={() => onChange(currentWeek)}
                disabled={!isCurrentBatch}>
                回到今天
            </Button>

            <Link to={"/course/list"} className={style.courseListLink}>
                <Badge dot count={isEvaluation ? 1 : 0}>
                    <span className={style.linkText}>课程列表</span>
                </Badge>
            </Link>
        </div>
    );
}
